/** The count up display for Cash Awards for Basegame, Freespins and the feature ending display for Cashlink */
class PowerPackAwardDisplay extends PIXI.Container {
  constructor() {
    super();
    this.currentPrizeIndex = 0;
    gameController.reelData = [];
    this.powerPacks = [];
    this.cashLinkStartData = [];
    this.currentCoinWinnings = 0;
    this.currentRoundWinnings = 0;
    this.currentPrizeData = undefined;
    this.currentPrizeObj = undefined;
    this.powerPackSymWinnings = 0;
    this.hit = false;
    this.currentPowerPackObj = undefined;
    this._skipped = false;
    this.hitSkipBefore = false;
    this.powerpackArr = [];
    this.cashLinkEndStake = undefined;

    messageBus.subscribe(
      "spinner:GameConfigEvent",
      this.onGameConfigEvent.bind(this)
    );

    messageBus.subscribe(
      "powerPack:coinAwardsStartEvent",
      this.onCoinAwardsStartEvent.bind(this)
    );

    messageBus.subscribe(
      "powerPack:cashLinkStartEvent",
      this.onCashLinkStartEvent.bind(this)
    );

    this.coinAwards = undefined;
    this.coinAwardsWinAmount = undefined;
    this.winCapped = undefined;

    this.culmiativeCoinAmount = 0;

    this.movedCoinValues = [];
    this.valueOverlays = [];
    this.prizes = [];

    this.movedFrenzyValues = [];
    this.coinCount = 0;
    this.powerPackCount = 0;
    this.powerPackOverlays = {};
    this.offsets = undefined;
    this.bigWin = undefined;
    this.collectSounds = ["collect1", "collect2", "collect3"];
    this.winningsPanel = resourceManager.get(
      "slotContainer:cashLinkFeatureContainer:moneyPanel"
    );
    this.winningsPanel.visible = false;
    this.winningsText = resourceManager.get(
      "slotContainer:cashLinkFeatureContainer:moneyPanel:winnings"
    );
  }

  initialise() {
    let index = 0;
    for (let reel = 0; reel < gameData.numReels; reel++) {
      for (let row = 0; row < gameData.numRows; row++) {
        const orginSymX = gameController.reelData[reel].position.x;
        const orginSymY =
          gameController.reelData[reel].position.y +
          gameController.reelData[reel]._symbolSpacing * row;
        const slotCell = reel * gameData.numRows + row;
        let powerPackOverlay;
        let powerPackDimOverlay;
        let powerPackTotalMovieOverlay;
        if (reel === 0 || reel === 5) {
          powerPackTotalMovieOverlay = resourceManager.createObject(
            "movie",
            `powerPackTotalMovie${slotCell}`,
            this,
            {
              definition: "Symbol_Power_Pack_Total",
              anchor: 0.5,
              loop: false,
              x: orginSymX - 2,
              y: orginSymY - 1.5,
            }
          );
          powerPackTotalMovieOverlay.visible = false;
          powerPackTotalMovieOverlay.gotoAndStop(0);

          powerPackOverlay = resourceManager.createObject(
            "text",
            `powerPackOverlay${slotCell}`,
            this,
            {
              text: PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
                0
              ),
              fontDefinition: "potAwards",
              x: orginSymX - 5,
              y: orginSymY + 26,
              fontSize: 25,
              width: 120,
              maxWidth: 120,
              anchor: 0.5,
            }
          );
          powerPackDimOverlay = resourceManager.createObject(
            "text",
            `powerPackDimOverlay${slotCell}`,
            this,
            {
              text: PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
                0
              ),
              fontDefinition: "potAwards",
              x: orginSymX - 5,
              y: orginSymY + 26,
              fontSize: 25,
              maxWidth: 120,
              anchor: 0.5,
              alpha: 0.5,
            }
          );
          powerPackOverlay.visible = false;
          powerPackDimOverlay.visible = false;

          this.powerPackOverlays[slotCell] = {
            powerPack: powerPackOverlay,
            powerPackDim: powerPackDimOverlay,
            powerPackTotalMovieOverlay: powerPackTotalMovieOverlay,
            powerPackOriginalPos: { x: orginSymX - 5, y: orginSymY + 26 },
          };
        }

        index++;
      }
    }

    this.fog = resourceManager.createObject("movie", "fog1x1", this, {
      definition: "fog1x1",
      anchor: 0.5,
      scale: 1.2,
    });

    this.fog.visible = false;
    this.fog.gotoAndStop(0);
    this.fog.loop = false;

    this._outroPopup = resourceManager.get(
      "featurePopupContainer:cashLinkOutroPopup"
    );
    this._outroPopup.visible = false;

    this.continueUp = resourceManager.get(
      "featurePopupContainer:cashLinkOutroPopup:backing:continueButton"
    );
    this.continueDown = resourceManager.get(
      "featurePopupContainer:cashLinkOutroPopup:backing:continueButton:continueDown"
    );
    this._outroPopupWinValue = resourceManager.get(
      "featurePopupContainer:cashLinkOutroPopup:backing:win"
    );
    this.congratulationsImg = resourceManager.get(
      "featurePopupContainer:cashLinkOutroPopup:backing:congratulationsTextImg"
    );
    this.congratulationsText = resourceManager.get(
      "featurePopupContainer:cashLinkOutroPopup:backing:congratulationsText"
    );
    this.youHaveWonText = resourceManager.get(
      "featurePopupContainer:cashLinkOutroPopup:backing:youHaveWonText"
    );
    this.youHaveWonImg = resourceManager.get(
      "featurePopupContainer:cashLinkOutroPopup:backing:youHaveWonImg"
    );

    this.popupMaskDimObject = resourceManager.get(
      "featurePopupContainer:darkBackground"
    );

    this._particleEmitter = particleManager.createEmitter(
      "coin_emitter",
      "slotContainer:reelEffects:particleContainer",
      0,
      0,
      false
    );

    this._particleEmitter.particleEmitter.emit = false;

    Reflex.registerEventHandler(
      "orientationChange",
      this.onOrientationChange.bind(this)
    );
  }

  onOrientationChange() {
    if (this.currentPrizeObj != null) {
      this._particleEmitter.x = this.currentPrizeObj.parent.x;
      this._particleEmitter.y = this.currentPrizeObj.parent.y;
    }
    if (this.fog.visible && this.currentPowerPackObj != null) {
      this.fog.x = this.currentPowerPackObj.position.x;
      this.fog.y = this.currentPowerPackObj.position.y - 30;
    }
  }

  onCashLinkStartEvent(task) {
    this.cashLinkStartTask = task;
  }

  onCoinAwardsStartEvent(task) {
    const self = this;
    gameController.inCoinAwardsModifier = true;
    this.hit = false;
    this.coinAwardsStartTask = task;
    this.coinAwardsStartTask.join();
    gameController.coinAwardsSkip = true;
    for (let i = 0; i < gameController.coinValues.length; i++) {
      if (gameController.coinValues[i].type === "Cash") {
        gameController.valuesSpin.showSpinCoinValue(
          false,
          gameController.coinValues[i].slotCell
        );
      } else {
        gameController.valuesSpin.hideAllSpinPots(
          gameController.coinValues[i].slotCell
        );
      }
    }

    this.coinAwards = task.data.coinAwards;
    this.coinAwardsWinAmount = task.data.winAmount;
    this.winCapped = task.data.winCapped;
    this.powerPacks = gameController.powerPackValues;

    gameController.ppTotalSymbolValue =
      this.coinAwardsWinAmount / this.powerPacks.length;

    this.sortPrizes();

    timerManager.addTimeout(800, function () {
      self.startDisplay();
    });
  }

  startCashLinkDisplay(
    coinAwards,
    powerPackValues,
    winAmount,
    winCapped,
    cb,
    isFullHouse
  ) {
    this.hit = false;
    this.cashLinkCB = cb;
    this.isFullHouse = isFullHouse;
    this.coinAwards = coinAwards;
    this.coinAwardsWinAmount = winAmount;
    this.winCapped = winCapped;
    this.powerPacks = powerPackValues;
    gameController.inCashLinkAwardDisplay = true;
    this.winningsText.setText(
      PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
        0
      )
    );

    let winAmt = this.coinAwardsWinAmount;
    if (this.isFullHouse) {
      winAmt =
        this.coinAwardsWinAmount - gameController.pots.megapotGlobalValue;
    }
    gameController.ppTotalSymbolValue =
      winAmt / gameController.cashLink.powerPacksCollected;

    this.sortPrizes();
    this.showCashLinkWinningsPanel(true);
    if (this.isFullHouse) {
      this.animationFullAnimation();
    } else {
      this.startDisplay();
    }
  }

  animationFullAnimation() {
    const self = this;
    let symbolData = [];
    for (let reel = 0; reel < gameData.numReels; reel++) {
      for (let row = 0; row < gameData.numRows; row++) {
        if (reel != 0 && reel != 5) {
          let sym = {
            cell: { reel: reel, row: row },
            symbolId: gameData.symbols["Symbol_Coin"].ID,
          };
          symbolData.push(sym);
        }
      }
    }

    gameController.pots.animatePot("Mega");

    gameController.bonusLandAnimator.animateSymbols(
      symbolData,
      gameController.slotMachine,
      true,
      false,
      function () {}
    );

    gameController.pots.animateCentreParticleIn();
    timerManager.addTimeout(200, () => {
      soundManager.play("cashLinkFullHouse");
    });
    timerManager.addTimeout(800, function () {
      gameController.pots.moveMegaValue(function () {
        self.countUpPrize(
          self.winningsText,
          0,
          gameController.pots.megapotGlobalValue,
          function () {
            self.startDisplay();
          },
          false
        );
      });
    });
  }

  sortPrizes() {
    // we want to fire off prizes in order of left to right reels and top to bottom on each reel
    // in the same order left to right/top to bottom
    let tempPrizes = [];

    for (let reel = 0; reel < gameData.numReels; reel++) {
      for (let row = 0; row < gameData.numRows; row++) {
        // search for each reel/row and if found add to tempPrizes
        for (let i = 0; i < this.coinAwards.length; i++) {
          if (
            this.coinAwards[i].reel === reel &&
            this.coinAwards[i].row === row
          ) {
            tempPrizes.push(this.coinAwards[i]);
            break;
          }
        }
      }
    }

    this.coinAwards = JSON.parse(JSON.stringify(tempPrizes));

    //remove prizes past the max win
    let runningTotal = 0;
    let i = 0;
    for (; i < this.coinAwards.length; i++) {
      runningTotal += this.coinAwards[i].amount;
      if (runningTotal >= this.getCurrentMaxWin()) {
        break;
      }
    }
    this.coinAwards.splice(i + 1, this.coinAwards.length - (i - 1));
  }

  skip() {
    this._skipped = true;
  }

  skipped() {
    const self = this;
    let total = this._megaPotWon ? this._megaPotValue : 0;
    gameController.cashLink.stopGlows();
    for (let i = 0; i < this.prizes.length; i++) {
      let prize = this.prizes[i];
      let prizeType = prize.type;

      if (prizeType === "Cash") {
        total += prize.amount;
      } else {
        total += prize.amount;
      }
    }

    let currentPowerPackObj = this.getPowerPackOverlay(
      this.powerPacks[this.powerPackCount - 1].slotCell
    );
    timerManager.addTimeout(500, function () {
      const value =
        PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
          total / 100
        );
      currentPowerPackObj.setText(value);
      self.showPowerPackValue(
        true,
        self.powerPacks[self.powerPackCount - 1].slotCell
      );
    });

    for (let i = this.powerPackCount; i < this.powerPacks.length; i++) {
      this.swapOverPowerPackSymbol(
        this.powerPacks[i].slotCell,
        function () {},
        true,
        i
      );

      let currentPowerPackObj = this.getPowerPackOverlay(
        this.powerPacks[i].slotCell
      );

      timerManager.addTimeout(500, function () {
        const value =
          PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
            total / 100
          );
        currentPowerPackObj.setText(value);
        self.showPowerPackValue(true, self.powerPacks[i].slotCell);
      });
    }

    this.prizes.forEach((prize) => {
      if (prize.type === "Cash") {
        gameController.topValueOverlays.showCoinDimValue(true, prize.slotCell);
      } else {
        gameController.topValueOverlays.showPotDimValue(
          true,
          prize.slotCell,
          prize.potName
        );
      }
      const prizeObj = gameController.topValueOverlays.getCoinContainer(
        prize.slotCell
      );
      prizeObj.visible = false;
    });

    const val = gameController.inCashLink
      ? this.coinAwardsWinAmount
      : gameController.ppTotalSymbolValue;

    timerManager.addTimeout(1000, function () {
      if (gameController.inCashLink) {
        self.showCashLinkWinningsPanel(true);
      }
      self.countUpPrize(self.winningsText, 0, val, function () {
        if (gameController.inCashLink) {
          timerManager.addTimeout(1000, function () {
            self.endFeature();
          });
        } else {
          self.endFeature();
        }
      });

      soundManager.play("coinSplash");
    });
  }

  showCashLinkWinningsPanel(show) {
    if (
      (show && !this.winningsPanel.visible) ||
      (!show && this.winningsPanel.visible)
    ) {
      if (show) {
        this.winningsPanel.visible = true;
        this.winningsPanel.alpha = 0;
      }
      const self = this;
      timerManager.addTimer(
        500,
        function (progress) {
          if (show) {
            self.winningsPanel.alpha = progress;
          } else {
            self.winningsPanel.alpha = 1 - progress;
          }
        },
        function () {
          self.winningsPanel.alpha = 1;
          if (!show) {
            self.winningsPanel.visible = false;
          }
        }
      );
    }
  }

  startDisplay() {
    const self = this;

    this.coinAwards.forEach(function (coin) {
      self.prizes.push({
        amount: coin.amount,
        reel: coin.reel,
        row: coin.row,
        slotCell: coin.slotCell,
        type: coin.type,
        symbolId: coin.symbolId,
        potName: coin.potName,
      });
    });

    this.showPowerPackWinningsPanel();
  }

  //Swaps over from powerpack landing symbols to powerpack total value symbols
  swapOverPowerPackSymbol(slotCell, cb, skipped, powerpackID) {
    if (!skipped) {
      soundManager.play("wolfRunSmokeOrPowerPackWind");
      this.fog.visible = true;
      this.fog.x = this.currentPowerPackObj.position.x;
      this.fog.y = this.currentPowerPackObj.position.y - 30;
      this.fog.gotoAndPlay(0);

      this.fog.onComplete = () => {
        this.fog.gotoAndStop(0);
        this.fog.visible = false;
      };
    }

    let oldPPSym;
    if (gameController.inCoinAwardsModifier) {
      oldPPSym = resourceManager.get(
        `slotContainer:reelContainer:reel${this.powerPacks[powerpackID].reel}:symbol${this.powerPacks[powerpackID].row}`
      );

      let symbolData = {
        cell: {
          reel: this.powerPacks[powerpackID].reel,
          row: this.powerPacks[powerpackID].row,
        },
        symbolId: gameData.symbols["Symbol_Power_Pack_Oversized"].ID,
      };
      gameController.hideOversized(symbolData);
    } else {
      oldPPSym = resourceManager.get(
        `slotContainer:cashLinkFeatureContainer:cashLinkFeature:powerPackOverlay${slotCell}`
      );
    }

    gsap.fromTo(
      oldPPSym,
      {
        alpha: 1,
      },
      {
        alpha: 0,
        duration: 0.25,
        onStart: () => {
          //hide symbol on reel
        },
        onComplete: () => {
          //fade in powerpack total symbol
          this.showNewPowerPack(slotCell, cb);
        },
      }
    );
  }

  showPowerPackOverlay(slotCell, show) {
    this.powerPackOverlays[slotCell].powerPackTotalMovieOverlay.visible = show;
  }

  showNewPowerPack(slotCell, cb) {
    let symbolData = {
      cell: {
        reel: this.powerPacks[this.powerPackCount].reel,
        row: this.powerPacks[this.powerPackCount].row,
      },
      symbolId: gameData.symbols["Symbol_Power_Pack_Oversized"].ID,
    };

    gsap.fromTo(
      this.powerPackOverlays[slotCell].powerPackTotalMovieOverlay,
      {
        alpha: 0,
      },
      {
        alpha: 1,
        duration: 0.25,
        onStart: () => {
          this.powerPackOverlays[
            slotCell
          ].powerPackTotalMovieOverlay.visible = true;
          gameController.hideOversized(symbolData);

          resourceManager.get(
            `slotContainer:reelContainer:reel${symbolData.cell.reel}:symbol${symbolData.cell.row}`
          ).visible = false;
          //hide symbol on reel
        },
        onComplete: () => {
          //fade in powerpack total symbol
          if (gameController.inCoinAwardsModifier) {
            gameData.reels[symbolData.cell.reel].showSymbol(
              symbolData.cell.row,
              false
            );
          } else {
            gameController.cashLink._slotMachineCL._reelVisuals[
              slotCell
            ].showSymbol(0, false);
          }
          this.powerPackOverlays[
            slotCell
          ].powerPackTotalMovieOverlay.gotoAndPlay(0);
          if (cb) {
            cb();
          }
          this.powerPackCount++;
        },
      }
    );
  }

  showPowerPackWinningsPanel() {
    const self = this;
    let slotCell = this.powerPacks[this.powerPackCount].slotCell;
    this.currentPowerPackObj = this.getPowerPackOverlay(slotCell);
    this.swapOverPowerPackSymbol(
      slotCell,
      function () {
        gsap.fromTo(
          self.currentPowerPackObj,
          {
            alpha: 0,
          },
          {
            alpha: 1,
            duration: 0.25,
            onStart: () => {
              soundManager.play("collectActivate");
              self.showPowerPackValue(true, slotCell);
            },
            onComplete: () => {
              self.processPrizes();
            },
          }
        );
      },
      self._skipped,
      self.powerPackCount
    );
  }

  swapPowerPackSymbols(slotCell, reel, row) {
    resourceManager.get(
      `slotContainer:reelContainer:reel${reel}:symbol${row}`
    ).visible = true;
    resourceManager.get(
      `slotContainer:reelContainer:reel${reel}:symbol${row}`
    ).alpha = 1;

    this.powerPackOverlays[slotCell].powerPackTotalMovieOverlay.visible = false;
    this.powerPackOverlays[slotCell].powerPackTotalMovieOverlay.alpha = 0;
  }

  processPrizes() {
    this._multipliers = [];
    this.currentPrizeIndex = 0;

    gameController.cashLinkPayout = true;

    if (this._skipped) {
      this.sortPrizes();
      this.skipped();
    } else {
      this.sortPrizes();

      this.processNextPrize();
    }
  }

  processNextPrize(callback) {
    const self = this;

    if (this._skipped) {
      this.skipped(callback);
      return;
    }

    if (this.currentPrizeIndex < this.prizes.length) {
      this.currentPrizeData = this.prizes[this.currentPrizeIndex++];
      this.processPrize();
    } else {
      //only need to set this once for the dimmed power pack amounts
      if (this.powerPackCount === 1) {
        this.powerPackSymWinnings = this.currentRoundWinnings;
      }
      this.setPowerPackDim();
      if (gameController.inCashLink) {
        if (self.powerPackCount < self.powerPacks.length) {
          self.resetValues();
          self.showPowerPackWinningsPanel();
        } else {
          this.powerpackArr = [];
          for (let i = 0; i < this.powerPacks.length; i++) {
            let slotCell = this.powerPacks[i].slotCell;
            this.powerpackArr.push(this.getPowerPackOverlay(slotCell));
            let endPos = layoutController.getCurrentPosition(
              this.winningsPanel.name
            );
            this.animateValueToWinningsPanel(
              this.powerpackArr,
              endPos,
              i === 0
            );
          }
        }
      } else {
        if (this.powerPackCount < this.powerPacks.length) {
          this.resetValues();
          this.showPowerPackWinningsPanel();
        } else {
          this.endFeature();
        }
      }
    }
  }

  setPowerPackDim() {
    const value =
      PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
        this.powerPackSymWinnings / 100
      );
    this.powerPackOverlays[
      this.powerPacks[this.powerPackCount - 1].slotCell
    ].powerPackDim.setText(value);
  }

  processPrize() {
    gameController.cashLink.animateQuickCoinGlow(
      this.currentPrizeData.slotCell
    );
    switch (this.currentPrizeData.type) {
      case "Cash": {
        this.currentPrizeObj = gameController.topValueOverlays.getCoinContainer(
          this.currentPrizeData.slotCell
        );
        this.collectPrize(this.currentPrizeObj, this.currentPowerPackObj, true);

        break;
      }
      case "Pot": {
        gameController.pots.animatePot(this.currentPrizeData.potName);
        this.processPotPrize(this.currentPrizeData);
        break;
      }
    }
  }

  collectPrize(objectToMove, objectToMoveTo, isCoin, cb) {
    let posX = objectToMove.x;
    let posY = objectToMove.y;
    let endPos = {
      x:
        layoutController.getCurrentPosition(objectToMoveTo.name).x -
        layoutController.getCurrentPosition(objectToMove.parent.name).x,
      y:
        layoutController.getCurrentPosition(objectToMoveTo.name).y -
        layoutController.getCurrentPosition(objectToMove.parent.name).y,
    };
    let speed = 15;
    let distanceX = Math.max(1, posX - endPos.x);
    let distanceY = Math.max(1, posY - endPos.y);
    let distance = distanceX + distanceY;
    let time = (1 + distance / 1000) / speed;
    let timeToTake = (time += 0.3); // added a manual offset at the request of prod. Tweak this number to make it slower/quicker.
    let randIndex = Math.floor(Math.random() * this.collectSounds.length);

    objectToMove.visible = true;

    this._particleEmitter.particleEmitter.cleanup();
    this._particleEmitter.x = objectToMove.parent.x;
    this._particleEmitter.y = objectToMove.parent.y;
    this._particleEmitter.particleEmitter.emit = true;

    soundManager.play(this.collectSounds[randIndex]);

    if (isCoin) {
      this.animateValues({ x: posX, y: posY }, endPos, timeToTake);
    }
  }

  animateValues(startPos, endPos, duration) {
    const self = this;
    gsap
      .timeline()
      .to(this.currentPrizeObj, {
        duration: 0.1,
        pixi: { scaleX: 1.3, scaleY: 1.3 },
        ease: "power1.out",
      })
      .to(this.currentPrizeObj, {
        duration: 0.1,
        pixi: { scaleX: 1, scaleY: 1 },
        ease: "power1.in",
        onComplete: () => {
          this.currentPowerPackObj.alpha = 1;
          if (this.currentPrizeData.type === "Cash") {
            gameController.topValueOverlays.showCoinDimValue(
              true,
              this.currentPrizeData.slotCell
            );
          } else {
            gameController.topValueOverlays.showPotDimValue(
              true,
              this.currentPrizeData.slotCell,
              this.currentPrizeData.potName
            );
          }
        },
      })
      .to(this.currentPrizeObj, {
        duration: duration,
        x: endPos.x,
        y: endPos.y,
        pixi: { scaleX: 0, scaleY: 0 },
        ease: "power3.in",
        onComplete: () => {
          if (
            gameController.inCoinAwardsModifier &&
            this.coinAwardsWinAmount <=
              resourceManager.getController("stakeController").getCurrentStake()
          ) {
            const value =
              PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
                gameController.ppTotalSymbolValue / 100
              );

            this.currentPowerPackObj.setText(value);
            this.processNextPrize();
          } else if (!this._skipped) {
            this.countUpPrize(
              this.currentPowerPackObj,
              this.currentRoundWinnings,
              this.currentRoundWinnings + this.currentPrizeData.amount,
              function () {
                self.currentRoundWinnings += self.currentPrizeData.amount;
                self.processNextPrize();
              }
            );
          } else {
            this.skipped();
          }
          this.currentPrizeObj.visible = false;
          this.currentPrizeObj.scale.set(1);
        },
      });
  }

  countUpPrize(gfxObject, countFrom, countTo, cb, isInitial = true) {
    var counter = { var: countFrom };

    gsap.to(counter, 1, {
      var: countTo,
      duration: 0.5,
      ease: Circ.easeOut,
      onStart: () => {
        if (isInitial) gameData.musicManager.startCountUp();
        this.inAnimation = true;
        gfxObject.visible = true;
      },
      onUpdate: () => {
        gfxObject.setText(gdk.formatCurrency(counter.var));
      },
      onComplete: () => {
        if (isInitial) gameData.musicManager.endCountUp();
        if (cb) {
          cb();
        }
      },
    });
  }

  getCurrentMaxWin() {
    if (gameController.inFirelink) {
      return this._maxWin - gameController.freespinsWinnings;
    } else {
      return this._maxWin;
    }
  }

  processPotPrize(prize, callback) {
    this.currentPrizeObj = gameController.topValueOverlays.getCoinContainer(
      prize.slotCell
    );

    gsap.fromTo(
      [this.currentPrizeObj],
      {
        pixi: { scaleX: 1, scaleY: 1 },
      },
      {
        duration: 0.25,
        pixi: { scaleX: 1.3, scaleY: 1.3 },
        yoyo: true,
        onStart: () => {},
        onComplete: () => {
          this.currentPrizeObj.scale.set(1, 1);
          gameController.topValueOverlays.showPotDimValue(
            true,
            prize.slotCell,
            prize.potName
          );
        },
      }
    );

    this.collectPrize(this.currentPrizeObj, this.currentPowerPackObj, true);
  }

  showPowerPackValue(show, slotCell) {
    this.powerPackOverlays[slotCell].powerPack.visible = show;
  }

  getPowerPackOverlay(slotCell) {
    return this.powerPackOverlays[slotCell].powerPack;
  }

  onGameConfigEvent() {
    this.initialise();
  }

  animateValueToWinningsPanel(powerpacks, endPos, isInitial = true) {
    const self = this;
    gsap
      .timeline()
      .to([powerpacks], {
        duration: 0.2,
        pixi: { scaleX: 1.3, scaleY: 1.3 },
        ease: "power1.out",
      })
      .to([powerpacks], {
        duration: 0.2,
        pixi: { scaleX: 1, scaleY: 1 },
        ease: "power1.in",
        onComplete: () => {
          [powerpacks].alpha = 1;
        },
      })
      .to([powerpacks], {
        duration: 0.5,
        x: endPos.x,
        y: endPos.y,
        pixi: { scaleX: 0, scaleY: 0 },
        ease: "power3.in",
        onComplete: () => {
          for (let i = 0; i < this.powerPacks.length; i++) {
            this.powerPackOverlays[
              this.powerPacks[i].slotCell
            ].powerPackDim.visible = true;
          }
          this.countUpPrize(
            this.winningsText,
            0,
            self.coinAwardsWinAmount,
            function () {
              if (!self.hit) {
                self.hit = true;
                self.endFeature();
              }
            },
            isInitial
          );
        },
      });
  }

  endFeature() {
    const self = this;

    soundManager.play("collectEnd");

    gameController.cashLinkPayout = false;
    gameController.inCoinAwardsModifier = false;

    for (let reel = 0; reel < 6; ++reel) {
      gameData.reels[reel].redraw();
    }

    this.showCashLinkWinningsPanel(false);

    if (gameController.inCashLink) {
      this.showOutro();
    } else {
      self.doBigWin();
    }
  }

  getCashLinkEndStake() {
    let cost;

    if (gameController.buyABonusCashLink) {
      let mode = "CASHLINK_BUY";
      let stake = resourceManager
        .getController("stakeController")
        .getCurrentStake(mode);
      let buyCost = buyBonusPopup.gameConfig.data.buyBonusCostFireball / 10;
      cost = stake * buyCost;
    } else {
      cost = resourceManager.getController("stakeController").getCurrentStake();
    }
    return cost;
  }

  showOutro() {
    let self = this;
    let lang;
    let congratsObject;
    let youHaveWonObject;

    lang = gdk.getConfigValue("lang");

    if (lang === "en") {
      congratsObject = this.congratulationsImg;
      this.congratulationsText.visible = false;

      youHaveWonObject = this.youHaveWonImg;
      this.youHaveWonText.visible = false;
    } else {
      congratsObject = this.congratulationsText;
      this.congratulationsImg.visible = false;

      youHaveWonObject = this.youHaveWonText;
      this.youHaveWonImg.visible = false;
    }

    gameController.cashLinkWinnings = this.coinAwardsWinAmount;
    this._outroPopupWinValue.setText(
      gdk.formatCurrency(this.coinAwardsWinAmount)
    );

    gsap.fromTo(
      congratsObject,
      {
        alpha: 0,
        y: congratsObject.y - 100,
      },
      {
        delay: 1,
        alpha: 1,
        y: -190,
        duration: 0.3,
        onStart: () => {},
        onComplete: () => {},
      }
    );

    gsap.fromTo(
      [this._outroPopup, this.popupMaskDimObject, this.youHaveWonText],
      {
        alpha: 0,
      },
      {
        alpha: 1,
        duration: 1,
        onStart: () => {
          gameData.musicManager.onCashLinkOutro();
          this._outroPopup.visible = false;
          this.popupMaskDimObject.visible = false;
        },
        onComplete: () => {
          this._outroPopup.visible = true;
          this.popupMaskDimObject.visible = true;
        },
      }
    );

    this.continueUp.interactive = true;

    this.continueUp.touchend = this.continueUp.mousedown = function () {
      self.continueUp.interactive = false;
      self.continueUp.visible = false;
      self.continueDown.visible = true;
      timerManager.addTimer(
        1000,
        function () {},
        function () {
          self.continueUp.visible = true;
          self.continueDown.visible = false;
          self._outroPopup.alpha = 0;
          self.popupMaskDimObject.visible = false;

          // cash link big win here
          self.doBigWin();
        }
      );
    };
  }

  doBigWin() {
    const self = this;
    const isBigWin = gameController.bigWin.checkBigWin(
      this.coinAwardsWinAmount
    );
    this.cashLinkEndStake = this.getCashLinkEndStake();

    if (gameController.inCoinAwardsModifier && !gameController.inFreeSpins) {
      gameController.preFSReelPrize = this.coinAwardsWinAmount;
    }

    if (self.coinAwardsWinAmount > this.cashLinkEndStake) {
      if (isBigWin) {
        gameController.bigWin.clearSkippedFlag();

        let wincap = false;

        if (gameController.inCashLink) {
          wincap = self.cashLinkStartTask.data.winCapped;
          gameController.hasBeenWinCapped =
            self.cashLinkStartTask.data.winCapped;
        }

        gameController.bigWin.start(
          self.coinAwardsWinAmount,
          function () {
            self.endCallback();
          },
          false,
          false,
          function () {},
          false,
          wincap
        );
      } else {
        this.endCallback();
      }
    } else {
      this.endCallback();
    }
  }

  endCallback() {
    if (gameController.inCashLink) {
      this.resetValues();
      if (!this._skipped) {
        this.resetNoSkipPowerPacks();
      }
      this.cashLinkCB();
    } else {
      gameController.wasInCoinAwardsMod = true;
      this.coinAwardsStartTask.leave();
      this.coinAwardsStartTask = undefined;
    }
    this._skipped = false;

    this.powerPacks.forEach(function (pack) {
      //Set/show total value to the power pack symbol so visible during spin off
      gameController.valuesSpin.setCoinSpinValue(
        pack.slotCell,
        self.currentRoundWinnings
      );
      gameController.valuesSpin.showSpinCoinValue(true, pack.slotCell);
      //Change reel symbol to total power pack symbol
      gameController.slotMachine.reels[pack.reel].setReelSymbol(
        pack.row,
        gameData.symbols["Symbol_Power_Pack_Total"].ID
      );
      //swap over to oversized powerpack total symbol
      let symbolData = {
        cell: {
          reel: pack.reel,
          row: pack.row,
        },
        symbolId: gameData.symbols["Symbol_Power_Pack_Total_Land"].ID,
      };
      gameController.showOversizeMovie(symbolData);
    });

    this.coinAwards.forEach(function (coin) {
      if (coin.type === "Cash") {
        gameController.valuesSpin.setCoinSpinValue(coin.slotCell, coin.amount);
        gameController.valuesSpin.showSpinCoinValue(true, coin.slotCell);
      } else {
        gameController.valuesSpin.showSpinPotValue(
          true,
          coin.slotCell,
          coin.potName
        );
      }
    });

    gameData.winningsMeter.add(this.coinAwardsWinAmount);
    gameData.winningsMeterMobile.add(this.coinAwardsWinAmount);
    if (this.coinAwardsWinAmount > 0) {
      gameController.winningsContainer.visible = true;
    }
  }

  resetValues(end = false) {
    let show = true;
    if (end) {
      show = false;
    }
    gameController.topValueOverlays.resetValuePostions();

    this.coinAwards.forEach(function (coin) {
      if (coin.type === "Cash") {
        gameController.topValueOverlays.showCoinValue(show, coin.slotCell);
        gameController.topValueOverlays.showCoinDimValue(false, coin.slotCell);
      } else {
        let potLabel = resourceManager.get(
          `slotContainer:topValueOverlays:parentContainer${
            coin.slotCell
          }:valueContainer:${coin.potName.toLowerCase()}Overlay`
        );
        potLabel.visible = show;

        resourceManager.get(
          `slotContainer:topValueOverlays:parentContainer${
            coin.slotCell
          }:dimValueContainer:${coin.potName.toLowerCase()}DimOverlay`
        ).visible = false;
      }
      if (end) {
        gameController.topValueOverlays.resetValues(coin.slotCell);
      }
    });

    this.currentRoundWinnings = 0;
  }

  dimPowerPackTotalSym(symbolData, showDim, time) {
    let targetTint = showDim ? 0x777777 : 0xffffff;
    //not sure about this one - trying to tint the symbol but it seems to only tint the children
    const slotCell =
      symbolData.cell.reel * gameData.numRows + symbolData.cell.row;
    const osToDim = this.getPowerPackOverlay(slotCell);
    if (osToDim) {
      gsap.killTweensOf(osToDim);

      if (time) {
        gsap.to(osToDim, {
          duration: time,
          pixi: { tint: targetTint },
        });
      } else {
        osToDim.tint = targetTint;
      }
    }
  }

  resetPowerPacks() {
    const self = this;
    this.powerPacks.forEach(function (pack) {
      let pp = self.getPowerPackOverlay(pack.slotCell);
      let ppd = self.powerPackOverlays[pack.slotCell].powerPackDim;
      pp.x = self.powerPackOverlays[pack.slotCell].powerPackOriginalPos.x;
      pp.y = self.powerPackOverlays[pack.slotCell].powerPackOriginalPos.y;
      pp.visible = false;
      ppd.visible = false;
      let ppv = self.getPowerPackOverlay(pack.slotCell);
      ppv.setText(gdk.formatCurrency(0));
      ppd.setText(gdk.formatCurrency(0));
    });
  }

  resetNoSkipPowerPacks() {
    const self = this;
    this.powerPacks.forEach(function (pack) {
      let pp = self.getPowerPackOverlay(pack.slotCell);
      pp.x = self.powerPackOverlays[pack.slotCell].powerPackOriginalPos.x;
      pp.y = self.powerPackOverlays[pack.slotCell].powerPackOriginalPos.y;
      pp.visible = true;
      pp.scale.set(1);
      pp.setText(gdk.formatCurrency(self.powerPackSymWinnings));
    });
  }

  resetPowerPacksValues(slotCell) {
    let pp = this.getPowerPackOverlay(slotCell);
    pp.setText(
      PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
        0
      )
    );
  }

  reset() {
    for (let i = 0; i < this.powerPacks.length; i++) {
      this.swapPowerPackSymbols(
        this.powerPacks[i].slotCell,
        this.powerPacks[i].reel,
        this.powerPacks[i].row
      );
    }

    this.isFullHouse = false;

    gameController.wasInPowerPackDisplay = true;
    this._skipped = false;
    this.resetValues(true);
    this.resetPowerPacks();
    this.fog.visible = false;
    this.powerPackCount = 0;
    this.currentCoinWinnings = 0;
    this.currentRoundWinnings = 0;
    this.coinAwardsWinAmount = 0;
    this.coinCount = 0;
    this.powerPacks = [];
    this.prizes = [];
    this.cashLinkStartData = [];
    this.coinAwards = [];
    this.currentPowerPackObj = undefined;
    this.currentPrizeObj = undefined;
  }
}

var powerPackAwardDisplayCreator = function (json) {
  return new PowerPackAwardDisplay();
};

var powerPackAwardDisplayInitialiser = function (json, buggy) {};

var powerPackAwardDisplayFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "PowerPackAwardDisplay",
  powerPackAwardDisplayCreator,
  powerPackAwardDisplayInitialiser,
  powerPackAwardDisplayFilesRequired
);
